// Reading Rails' CSRF token out of the page.
//
// Every call site used to inline document.querySelector(...).content, in five different
// spellings, ten of them unguarded. Whenever csrf_meta_tags renders nothing, that read threw
// a TypeError while the fetch options object was still being built, so the request never left
// the browser and no .catch or response.ok check downstream could report it. To the user the
// click simply did nothing. See #976.
//
// The tag is genuinely absent more often than it looks: a layout that omits the helper, a
// cached page fragment, an extension that strips meta tags, and the entire test environment,
// where allow_forgery_protection is false and csrf_meta_tags returns nil.
//
// Omitting the header is strictly better than throwing before send. Rails answers a
// state-changing request that carries no token with a 422, which is a response every call site
// can already see, and which lands in the logs and SigNoz besides. A dead click is invisible.
//
// The selector is pinned to meta[...] on purpose. Some call sites matched on [name="csrf-token"]
// alone, which a form input of that name also satisfies, and an input has no .content.

const CSRF_META_SELECTOR = 'meta[name="csrf-token"]'

/**
 * @returns {string|null} the token, or null when the page carries no csrf meta tag
 */
export function csrfToken() {
  return document.querySelector(CSRF_META_SELECTOR)?.content || null
}

/**
 * Headers for a state-changing fetch. Omits X-CSRF-Token entirely when there is no token
 * rather than sending undefined, which serialises to the literal string 'undefined' and fails
 * as though the token were wrong.
 *
 * @param {Object} [headers] headers to merge the token into
 * @returns {Object}
 */
export function csrfHeaders(headers = {}) {
  const token = csrfToken()

  return token ? { ...headers, 'X-CSRF-Token': token } : { ...headers }
}
